/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_Faq_A1Inputs */

const en_guide_json_schema_faq_a1 = /** @type {(inputs: Guide_Json_Schema_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The basics are straightforward: you can start validating data with just <code>type</code>, <code>required</code>, and <code>properties</code>. Advanced features like conditional schemas and references take more time but aren't needed for most use cases.`)
};

const ko_guide_json_schema_faq_a1 = /** @type {(inputs: Guide_Json_Schema_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기본은 간단합니다: <code>type</code>, <code>required</code>, <code>properties</code>만으로 데이터 검증을 시작할 수 있습니다. 조건부 스키마와 참조 같은 고급 기능은 더 많은 시간이 필요하지만 대부분의 사용 사례에는 필요하지 않습니다.`)
};

const ja_guide_json_schema_faq_a1 = /** @type {(inputs: Guide_Json_Schema_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基本は簡単です: <code>type</code>、<code>required</code>、<code>properties</code>だけでデータ検証を始められます。条件付きスキーマや参照などの高度な機能は習得に時間がかかりますが、ほとんどのユースケースでは不要です。`)
};

/**
* | output |
* | --- |
* | "The basics are straightforward: you can start validating data with just <code>type</code>, <code>required</code>, and <code>properties</code>. Advanced featu..." |
*
* @param {Guide_Json_Schema_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_faq_a1 = /** @type {((inputs?: Guide_Json_Schema_Faq_A1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_Faq_A1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_faq_a1(inputs)
	if (locale === "ko") return ko_guide_json_schema_faq_a1(inputs)
	return ja_guide_json_schema_faq_a1(inputs)
});